<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>Ciao!</ion-title>
    <ion-buttons slot="end">
      <ion-button *ngIf="!isMenu" (click)="logout()">
        <ion-icon slot="start" name="exit-outline"></ion-icon>
        Esci
      </ion-button>
      <ion-button *ngIf="isMenu" (click)="modalController.dismiss()">
        <ion-icon slot="icon-only" name="close" color="white"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card mode="ios">
    <ion-card-header>
      <ion-card-title color="light">Inserisci qui sotto il tuo codice di invito al canale</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-input color="light" [(ngModel)]="code" class="ion-margin-vertical" [autofocus]="true" type="text" inputmode="text" placeholder="Codice invito" style="color: white; font-weight: 500;"></ion-input>
      <ion-button *ngIf="error" [disabled]="true" fill="clear">
        {{error}}
      </ion-button>
      <ion-button (click)="checkInviteCode()" [disabled]="sent || code.length < 6 || code.length > 6" expand="block">
        <ion-spinner *ngIf="sent"></ion-spinner>
        invia
      </ion-button>
    </ion-card-content>
  </ion-card>

  <div id="tlogo">
    <img src="../../assets/img/logo-tempo-white.png" height="90">
  </div>
  
</ion-content>
